import axios from "axios";
import { config, getDomain, tempAlErr, tempAlWait } from "../helpers"
import { alertIndex } from "../helpers/alertIndex";
import { ACTU_DEL, ACTU_DETAILS, ACTU_LIKE, ACTU_LIST, ACTU_SAVE, ACTU_VIEW } from "./action-types";

// Ajouter / Modifier une actu
export function saveActu({
    title,
    desc,
    codeYtb,
    duree,
    contenu,
    nbVue = 0,
    actuId = null,
}) {
    return function (dispatch) {
        let alert = tempAlWait();
        let url = `${getDomain()}api/blog/save`;
        if (actuId != null) {
            url += `/${actuId}`;
        }
        
        axios.post(url, {
            title: title,
            description: desc,
            codeYtb: codeYtb,
            duree: duree,
            contenu: contenu,
            nbVue: nbVue,
            userId: localStorage.getItem('userId'),
            credentials: localStorage.getItem('userCred')
        }, config)
            .then(res => {
                res = res.data;
                alert = alertIndex(res.res.code);

                dispatch({
                    type: ACTU_SAVE,
                    payload: {
                        alert: alert
                    }
                })
            })
            .catch(err => {
                console.log(err);
                alert = tempAlErr("blsa005");
                dispatch({
                    type: ACTU_SAVE,
                    payload: {
                        alert: alert
                    }
                })
            })
    }
}

// Supprimer une acto
export function delActu({actuId}) {
    return function (dispatch) {
        let alert = tempAlWait();
        let isNext = false;

        axios.post(`${getDomain()}api/blog/delete/${actuId}`, {
            credentials: localStorage.getItem('userCred'),
            userId: localStorage.getItem('userId')
        }, config)
            .then(res => {
                res = res.data;
                alert = alertIndex(res.res.code);

                if (res.res.type == "succ") {
                    isNext = true;
                }

                dispatch({
                    type: ACTU_DEL,
                    payload: {
                        alert: alert,
                        isNext: isNext
                    }
                })
            })
            .catch(err => {
                console.log(err);
                alert = tempAlErr("blde004");
                dispatch({
                    type: ACTU_DEL,
                    payload: {
                        alert: alert,
                        isNext: isNext
                    }
                })
            })
    }
}

// Détails d'une actu
export function detailsActu({actuId}) {
    return function (dispatch) {
        let alert = tempAlWait();
        let datas = null;

        axios.post(`${getDomain()}api/blog/details/${actuId}`, {
            userId: localStorage.getItem('userId'),
            credentials: localStorage.getItem('userCred')
        }, config)
            .then(res => {
                res = res.data;
                alert = alertIndex(res.res.code);

                if (res.res.type == "succ") {
                    datas = res.datas;
                }

                dispatch({
                    type: ACTU_DETAILS,
                    payload: {
                        alert: alert,
                        datas: datas
                    }
                })
            })
            .catch(err => {
                console.log(err);
                alert = tempAlErr("bldet002");
                dispatch({
                    type: ACTU_DETAILS,
                    payload: {
                        alert: alert,
                        datas: datas
                    }
                })
            })
    }
}

// Lister les actus
export function listActu({nb}) {
    return function (dispatch) {
        let alert = tempAlWait();
        let datas = [];
        let url = `${getDomain()}api/blog/list`;
        if (nb != undefined && nb != null) {
            url += `/${nb}`;
        }
        
        axios.post(url, {
            userId: localStorage.getItem('userId'),
            credentials: localStorage.getItem('userCred')
        }, config)
            .then(res => {
                res = res.data;
                alert = alertIndex(res.res.code);

                if (res.res.type == "succ") {
                    datas = res.datas;
                }

                dispatch({
                    type: ACTU_LIST,
                    payload: {
                        alert: alert,
                        datas: datas
                    }
                })
            })
            .catch(err => {
                console.log(err);
                alert = tempAlErr("blli002");
                dispatch({
                    type: ACTU_LIST,
                    payload: {
                        alert: alert,
                        datas: datas
                    }
                })
            })
    }
}

// Mettre un like à une actu
export function likeActu({actuId}) {
    return function (dispatch) {
        let alert = tempAlWait();
        let isNext = false;

        axios.post(`${getDomain()}api/blog/like/${actuId}`, {
            credentials: localStorage.getItem('userCred'),
            userId: localStorage.getItem('userId')
        }, config)
            .then(res => {
                res = res.data;
                alert = alertIndex(res.res.code);

                if (res.res.type == "succ") {
                    isNext = true;
                }

                dispatch({
                    type: ACTU_LIKE,
                    payload: {
                        alert: alert,
                        isNext: isNext
                    }
                })
            })
            .catch(err => {
                console.log(err);
                alert = tempAlErr("bllk003");
                dispatch({
                    type: ACTU_LIKE,
                    payload: {
                        alert: alert,
                        isNext: isNext
                    }
                })
            })
    }
}

// Mettre à jour le nb de vue
export function vueActu({actuId}) {
    return function (dispatch) {
        let alert = tempAlWait();
        let isNext = false;

        axios.post(`${getDomain()}api/blog/vue/${actuId}`, {}, config)
            .then(res => {
                res = res.data;
                alert = alertIndex(res.res.code);

                if (res.res.type == "succ") {
                    isNext = true;
                }

                dispatch({
                    type: ACTU_VIEW,
                    payload: {
                        alert: alert,
                        isNext: isNext
                    }
                })
            })
            .catch(err => {
                console.log(err);
                alert = tempAlErr("blvu002");
                dispatch({
                    type: ACTU_VIEW,
                    payload: {
                        alert: alert,
                        isNext: isNext
                    }
                })
            })
    }
}